import AUSIcon from "../_icons/flags/ausIcon";
import CanadaIcon from "../_icons/flags/canadaIcon";
import IrelandIcon from "../_icons/flags/irelandIcon";
import UkIcon from "../_icons/flags/ukIcon";
import USAIcon from "../_icons/flags/usaIcon";
import { PhoneLocaleOptions } from "./localizedTypes";

// index string is converted to lowercase to make sure
// there are no differences in the way it's passed from outside of the component
export const localeOptions: Partial<PhoneLocaleOptions> = {
  "en-US": {
    placeholder: "(###) ###-####",
    format: "(###) ###-####",
    countryCode: "+1",
    minimumLength: 10,
    localizationString: "United States (English)",
    countryName: "United States",
    flag: <USAIcon width="24" height="24" />,
  },
  "en-CA": {
    placeholder: "(###) ###-####",
    format: "(###) ###-####",
    countryCode: "+1",
    minimumLength: 10,
    localizationString: "Canada (English)",
    countryName: "Canada",
    flag: <CanadaIcon width="24" height="24" />,
  },
  "en-AU": {
    placeholder: "0X XXXX XXXX",
    format: "0# #### ####",
    mobilePlaceholder: "0XXX XXX XXX",
    mobileFormat: "0### ### ###",
    countryCode: "+61",
    minimumLength: 10,
    numberPrefix: "0",
    localizationString: "Australia (English)",
    countryName: "Australia",
    flag: <AUSIcon width="24" height="24" />,
    hasDifferentFormats: true,
  },
  "en-IE": {
    placeholder: "0XX XXX XXXX",
    format: "0## ### ####",
    countryCode: "+353",
    minimumLength: 10,
    numberPrefix: "0",
    localizationString: "Ireland (English)",
    countryName: "Ireland",
    flag: <IrelandIcon width="24" height="24" />,
  },
  "en-GB": {
    placeholder: "0XXXX XXXXXX",
    format: "0#### ######",
    minimumLength: 11,
    numberPrefix: "0",
    countryCode: "+44",
    localizationString: "United Kingdom (English)",
    countryName: "United Kingdom",
    flag: <UkIcon width="24" height="24" />,
  },
};

export const naLocaleOptions: Partial<PhoneLocaleOptions> = {
  "en-US": localeOptions["en-US"]!,
  "en-CA": localeOptions["en-CA"]!,
};

export const apacLocaleOptions: Partial<PhoneLocaleOptions> = {
  "en-AU": localeOptions["en-AU"]!,
};

export const emeaLocaleOptions: Partial<PhoneLocaleOptions> = {
  "en-IE": localeOptions["en-IE"]!,
  "en-GB": localeOptions["en-GB"]!,
};
